
<app-mu-table
  contextLang="massive.services"
  [columns]="tableListColumns"
  [filters]="filters"
  [responsive]="true"
  [flags]="flags"
  [flagEmpty]="massiveServiceFlags.LOAD_SERVICES_TABLE"
  [dataList]="dataList"
  [paginator]="true"
  [bodyTrTarget]="'serviceId'"
>
  <ng-template appMuTableCaption>
    <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
      <app-massive-deliveries-bread-crumb
        title="{{ 'context.massive.services.initialSelection' | translate }}"
        [items]="breadCrumbItems"
      ></app-massive-deliveries-bread-crumb>
    </div>

    <div class="p-col-12 p-md-2 p-lg-2 p-xl-2">
      <app-mu-button
        class="mu-button-outline show-map-button"
        icon="mu-icon-marker"
        label="{{ 'context.massive.services.showMap' | translate }}"
        [disabled]="!(dataList && selectedServices?.length>0)"
        [flag]="massiveServiceFlags.SHOW_MAP_FULLSCREEN"
        [flagList]="flags"
      ></app-mu-button>
    </div>

    <div class="p-col-12 p-md-2 p-lg-2 p-xl-2">
      <app-mu-button
        class="mu-button-outline file-upload-button"
        icon="fa-plus"
        label="{{ 'context.massive.services.loadFile' | translate }}"
        [disabled]="!dataList"
        [flag]="massiveServiceFlags.SHOW_LOAD_FILE"
        [flagList]="flags"
      ></app-mu-button>
    </div>

    <div class="p-col-12 p-md-2 p-lg-2 p-xl-2">
      <app-mu-button
        label="{{ 'context.massive.services.continue' | translate }}"
        [disabled]="!(dataList && selectedServices?.length>0)"
        [flag]="massiveServiceFlags.CREATE_SERVICES"
        [flagList]="flags"
      ></app-mu-button>
    </div>

    <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
        <app-deliveries-filters-toolbar
          class="p-col-12 mu-without-padding"
          #filterToolbarService
          [flagList]="flags"
          [filterFieldList]="filterFields"
          [filterList]="filters"
          [localityList]="localityList"
          [weightList]="weightList"
      ></app-deliveries-filters-toolbar>
    </div>
  </ng-template>

  <ng-template [appMuTableFilter]="filterColumns.CHECKBOX" let-column>
    <div class="p-field mu-without-padding">
      <p-checkbox name="selectedAllServices" [(ngModel)]="isCheckAll" [binary]="true" (onChange)="checkAll()"> </p-checkbox>
    </div>
  </ng-template>

  <ng-template [appMuTableCell]="filterColumns.CHECKBOX" let-column let-row="row">
    <div class="p-field mu-without-padding">
      <p-checkbox
        name="selectedServices"
        [value]="row"
        [inputId]="row"
        [(ngModel)]="selectedServices"
        (onChange)="updateSelectedServices()"
      ></p-checkbox>
    </div>
  </ng-template>

  <ng-template [appMuTableCell]="'idClient'" let-column let-row="row">
    <div class="ctx-idclient-cell">
      <div class="ctx-error-address" *ngIf="row.wrongAddress"></div>
      <div pTooltip="{{ column.getValue(row) }} / {{ row.orderId }}" tooltipPosition="top" class="ctx-idclient-value">
        {{ column.getValue(row) }} / <br />
        {{ row.orderId }}
      </div>
    </div>
  </ng-template>

  <ng-template [appMuTableCell]="'address'" let-column let-row="row">
    <span class="{{ 'address_status_' + row.status }}">
      {{ column.getValue(row) }}
    </span>
  </ng-template>

  <ng-template [appMuTableCellEditor]="'lat'" let-column let-row="row">
    <input pInputText type="text" [(ngModel)]="row[column.key]" class="ctx-cell-editor" />
    <input pInputText type="text" [(ngModel)]="row.lng" class="ctx-cell-editor" />
  </ng-template>

  <ng-template [appMuTableCellEditor]="" let-column let-row="row">
    <textarea pInputText [(ngModel)]="row[column.key]" class="ctx-cell-editor"></textarea>
  </ng-template>

  <ng-template [appMuTableCell]="'options'" let-column let-row="row" let-editor="editor">
    <app-mu-table-options
      [data]="row"
      [tableOptionList]="tableOptionListEdition"
      [showAlways]="true"
      [checkPermissions]="false"
      [tableRowEditor]="editor"
      [actions]="actionsEdition"
    ></app-mu-table-options>
  </ng-template>

  <ng-template [appMuTableCell]="'phone'" let-column let-row="row">
    <span>
      {{ row.phone }}
    </span>
  </ng-template>

  <ng-template [appMuTableCell]="'size'" let-column let-row="row">
    <span>
      {{ row.size }}
    </span>
  </ng-template>

  <ng-template [appMuTableCell]="'received'" let-column let-row="row">
    <span>
      {{ row.received }}
    </span>
  </ng-template>

  <ng-template [appMuTableCell]="'createdDate'" let-column let-row="row">
    <span>
      {{ row.createdDate }}
    </span>
  </ng-template>

  <ng-template [appMuTableCell]="'deliveryDate'" let-column let-row="row">
    <span>
      {{ row.deliveryDate }}
    </span>
  </ng-template>

  <ng-template [appMuTableCell]="'locality'" let-column let-row="row">
    <span>
      {{ row.locality }}
    </span>
  </ng-template>
  
</app-mu-table>

<app-mu-filter-toolbar-sidebar
  *ngIf="isViewChecked"
  [filterToolbar]="filterToolbarService"
  [disableDeleteFilter]="disableDeleteFilter"
  [actions]="actionsSelection"
></app-mu-filter-toolbar-sidebar>

<app-deliveries-map
  *ngIf="flags?.get(massiveServiceFlags.SHOW_MAP_FULLSCREEN)"
  [flagList]="flags"
  [markers]="markers"
></app-deliveries-map>